
export const FORM_TYPE_KEY = {
    FRM_GUIA_PADRES : "FRM_GUIA_PADRES",
    FRM_ANIVERARIO_MATRIMONIO : "FRM_ANIVERSARIO_MATRIMONIO",
    FRM_AYUDA_ESPECIAL : "FRM_AYUDA_ESPECIAL",
    FRM_AYUDA_ESPECIAL_REEMBOLSO : "FRM_AYUDA_ESPECIAL_REEMBOLSO",
    FRM_EXCELENCIA_ARTES : "FRM_EXCELENCIA_ARTES",
    FRM_BECA_POSTGRADO : "FRM_BECA_POSTGRADO",
    FRM_SALACUNA_PADRE : "FRM_SALACUNA_PADRE",
    FRM_RECEPCION_VIVIENDA : "FRM_RECEPCION_VIVIENDA",
    FRM_CONSULTAS_ABOGADO : "FRM_CONSULTAS_ABOGADO",
    FRM_PRESTAMO_VIAJE : "FRM_PRESTAMO_VIAJE",
    FRM_FONDO_DEPORTISTA : "FRM_FONDO_DEPORTISTA",
    FRM_FONDO_DEPORTISTA_REEMBOLSO : "FRM_FONDO_DEPORTISTA_REEMBOLSO",
    FRM_REEMB_ANTICONCEPTIVO:"FRM_REEMB_ANTICONCEPTIVO",
    FRM_OC_OPTICA:"FRM_OC_OPTICA",
    FRM_REEMB_EXAMEN_PREVENTIVO:"FRM_REEMB_EXAMEN_PREVENTIVO",
    FRM_REEMB_EXAMEN_PREVENTIVO_OVER:"FRM_REEMB_EXAMEN_PREVENTIVO_OVER",
    FRM_REEMB_PROCEDIMIENTO_ANTICONCEPTIVO:"FRM_REEMB_PROCEDIMIENTO_ANTICONCEPTIVO",
    FRM_LEGAL_ADVICE_FREE: "FRM_LEGAL_ADVICE",
    FRM_PRESTAMO_COMPANIA:"FRM_PRESTAMO_COMPANIA",
    FRM_FONDO_LIBRE_DISPOSICION:"FRM_FONDO_LIBRE_DISPOSICION",
    FRM_SEGURO_COMPLEMENTARIO_SALUD_JUBILADOS:"FRM_SEGURO_COMPLEMENTARIO_SALUD_JUBILADOS",
    FRM_SALUD_DENTAL : "FRM_SALUD_DENTAL",
    FRM_SOLICITUD_COLECTIVA_TRABAJADOR: "SOLICITUD_COLECTIVA_TRABAJADOR",
    FRM_BECA_EDUCACION: "FRM_BECA_EDUCACION",
    FRM_ACTIVIDADES_EXTRAPROGRAMATICAS: "FRM_ACTIVIDADES_EXTRAPROGRAMATICAS",
    FRM_BECA_CONYUGE: "FRM_BECA_CONYUGE",
    FRM_BECA_PAES: "FRM_BECA_PAES",
    FRM_RECRE_ARTE: "FRM_RECRE_ARTE",
    FRM_DESTACAME_PRO: "FRM_DESTACAME_PRO",
    FRM_EXAMENES_PREVENTIVOS_MAYORES: "FRM_EXAMENES_PREVENTIVOS_MAYORES",
    FRM_DEPARTAMENTO_MERCED: "FRM_DEPARTAMENTO_MERCED",
    FRM_CLUB_COPEC: "FRM_CLUB_COPEC",
    FRM_RESERVA_PISCINA: "FRM_RESERVA_PISCINA",
    FRM_AYUDA_DISTANCIA: "FRM_AYUDA_DISTANCIA",
    FRM_CARTA_RESGUARDO: "FRM_CARTA_RESGUARDO",
    FRM_PRESTAMO_BIENESTAR:"FRM_PRESTAMO_BIENESTAR",
    FRM_PRESTAMO_COMPRA_VIVIENDA:"FRM_PRESTAMO_COMPRA_VIVIENDA",
    FRM_PRESTAMO_REPARACION_VIVIENDA:"FRM_PRESTAMO_REPARACION_VIVIENDA",
    FRM_PRESTAMO_LIBRE_DISPOSICION:"FRM_PRESTAMO_LIBRE_DISPOSICION",
    FRM_AYUDA_NATALIDAD: "FRM_AYUDA_NATALIDAD",
    FRM_AYUDA_CUOTA_MORTUORIA:"FRM_AYUDA_CUOTA_MORTUORIA",
    FRM_AYUDA_MATRIMONIO: "FRM_AYUDA_MATRIMONIO",
    FRM_PREMIO_EDUCACION: "FRM_PREMIO_EDUCACION",
    FRM_CABANA_EL_QUISCO: "FRM_CABANA_EL_QUISCO",
    FRM_SEGURO_FAMILIAR_SANTAMARIA: "FRM_SEGURO_FAMILIAR_SANTAMARIA",
    FRM_GYM_MEMBERSHIP: "FRM_GYM_MEMBERSHIP",
    FRM_ACADEMIC_EXCELLENCE:"FRM_ACADEMIC_EXCELLENCE",
    FRM_VACCINATION_PROGRAM: "FRM_VACCINATION_PROGRAM",
    FRM_BONO_VACACIONES: "FRM_BONO_VACACIONES",
    FRM_MEDIC_HEALTH_DENTAL_CREDIT: "FRM_MEDIC_HEALTH_DENTAL_CREDIT",
    FRM_AJUAR_NACIMIENTO:"FRM_AJUAR_NACIMIENTO",
    FRM_CHRISTMAS_BOX:"FRM_CHRISTMAS_BOX",

    PLAN_BASE: 1, 
    PLAN_PERSONAL: 2, 
    PLAN_DUO: 3, 
    PLAN_FAMILIAR: 4 ,
    FRM_CAMBIO_PLAN: "FRM_CAMBIO_PLAN"
}

// IDs de Beneficios
export const BENEFICIO_ID = {
    PRESTAMO_VIAJE: 69,
    RECEPCION_VIVIENDA: 11,
    PRESTAMO_BIENESTAR: 64,
    PRESTAMO_COMPRA_VIVIENDA: 66,
    PRESTAMO_REPARACION_VIVIENDA: 68,
    PRESTAMO_LIBRE_DISPOSICION: 67,
    PROGRAMA_VACUNACION: 76,
    EXAMENES_PREVENTIVOS_MAYORES: 36,
    BONO_VACACIONES: 23,
    AYUDA_ESPECIAL_TRABAJADOR: 8,
    FONDO_DEPORTISTA_SELECCIONADO: 39,
    FONDO_LIBRE_DISPOSICION: 40,
    REEMBOLSO_ANTICONCEPTIVO: 82,
    REEMBOLSO_PROCEDIMIENTO_ANTICONCEPTIVO: 83,
    INCORPORACION_BENEFICIARIO: 86,
    SEGURO_COMPLEMENTARIO_ADICIONAL: 100,
}

// Estados de Solicitudes
export const ESTADO_SOLICITUD = {
    PENDIENTE: 1,
    APROBADA: 2,
    RECHAZADA: 3
}


